import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Highmark Blue Shield of Northeastern New York",
  shortName: "Highmark Blue Shield NE NY",
  slug: "highmark-blue-shield-ne-ny-insurance",
  seoTitle:
    "Highmark Blue Shield of Northeastern New York TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Highmark Blue Shield of Northeastern New York policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "Highmark Blue Shield NE NY TMS coverage, Highmark Blue Shield Northeastern New York SPRAVATO authorization, Highmark NE NY mental health benefits Coral Springs FL",
};

export const HighmarkBlueShieldNeNyInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default HighmarkBlueShieldNeNyInsurance;
